// extracted by mini-css-extract-plugin
export default {"root":"CategoryIcon_root__1q-SF","image":"CategoryIcon_image__-XMYY"};